<template>
    <div class="live mobile content h-full w-full fixed flex-col sm:flex-row flex overflow-hidden">
        <div v-if="loading" class="w-full h-full flex flex-col justify-center content-center items-center uppercase text-sm">
            <img class="mb-4 w-64" src="@live/assets/images/logo-20-m.svg" />
            {{ $t('general.loading') }}
        </div>
        <template v-else>
            <div class="bg-black px-4 py-4 flex flex-row sm:flex-col justify-between">
                <button class="my-2 hamburger hamburger--squeeze flex justify-center items-center" :class="{'is-active': showLots}" type="button" @click="toggleLots">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>
                <div class="flex items-center">
                    <div v-if="lot" class="text-center text-white text-xl font-bold">
                        <template v-if="maxLot > 0">{{ maxLot }}</template>
                        <template v-else>{{ firstLot }}</template>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-white mx-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                    <div v-if="lots" class="text-center text-gray-500 text-sm font-bold">{{ lastLot }}</div>
                </div>
                <div class="flex items-center">
                    <div v-if="auction" class="text-center text-white text-sm font-bold">#{{ auction.no }}</div>
                    <div class="text-center text-gray-500 text-xs font-bold pl-1">({{ progress }}%)</div>
                </div>
            </div>
            <div class="lots-list flex flex-col sm:flex-row container-fluid w-full h-full">
                <!-- Lista loturi -->
                <transition name="fade">
                    <lots v-if="showLots && lots && lots.length > 0"></lots>
                </transition>
                <!-- Lot curent, bid, desfasurare -->
                <transition name="fade">
                    <bid v-if="lot"></bid>
                    <div v-else class="lot-live-details no-lot flex-1 p-4 bg-white flex flex-col justify-center items-center">
                        {{ $t('general.loading') }}
                    </div>
                </transition>
            </div>
        </template>
        <Welcome />
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import Vue from 'vue'
import Lots from './components/mobile/Lots'
import Bid from './components/mobile/Bid'
import { Constants } from './constants'

import AbsenteeBid from './components/modals/AbsenteeBid'
import BidMore from './components/modals/BidMore'
import ConfirmBid from './components/modals/ConfirmBid'
import LotRecall from './components/modals/LotRecall'
import LotReminder from './components/modals/LotReminder'
import Welcome from './components/modals/Welcome'

export default {
    name: 'Mobile',
    components: {
        Lots, Bid, AbsenteeBid, BidMore, ConfirmBid, LotRecall, LotReminder, Welcome
    },
    data () {
        return {
            ...Constants,
        }
    },
    computed: {
        ...mapGetters({
            loading: 'getLoading',
            user: 'getUser',
            auction: 'getAuction',
            lot: 'getLot',
            lots: 'getLots',
            bidders: 'getBidders',
            showLots: 'getShowLots',
            bids: 'getBids',
            winner: 'getWinner',
        }),
        firstLot() {
            return Math.min.apply(Math, this.lots.map(lot => lot.no))
        },
        lastLot () {
            return Math.max.apply(Math, this.lots.map(lot => lot.no))
        },
        maxLot () {
            return Math.max.apply(Math, this.lots.filter(lot => {return [this.LOT_AUCTION_STATUS_SOLD, this.LOT_AUCTION_STATUS_UNSOLD, this.LOT_AUCTION_STATUS_OPEN].includes(lot.s)}).map(lot => lot.no))
        },
        progress () {
            if(this.maxLot > 0) {
                return Math.ceil(this.maxLot / this.lastLot * 100)
            } else {
                return Math.ceil(this.firstLot / this.lastLot * 100)
            }
        }
    },
    methods: {
        toggleLots() {
            this.$store.dispatch('toggleLotsVisibility');
            if(! this.lot) return
            this.$nextTick(() => {
                let el = document.getElementById(`lot-id-${this.lot.id}`)
                if(el) {
                    el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' })
                }
            });
        }
    },
    mounted () {
        this.$modal.show('welcome')
    }
}
</script>
